// extracted by css-extract-rspack-plugin
export default {"y-split":"YSplit_y-split__1+Ew8"};